import API from '../infraestructure/api';
import ApiError from './apiError';

export async function getServiceNumbers(data = '') {
  try {
    const response = await API.get(`/numbers?_id=${data}`);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/numbers/', message: `Hubo un problema al intentar buscar correlativos. ${message}` });
  }
}

export async function putServiceNumbers(data) {
  try {
    const response = await API.put('/numbers', data);
    if (response && response.data) {
      return response.data;
    }
    return {};
  } catch (error) {
    const message = (error && error.response && error.response.data && error.response.data.message) || '';
    throw ApiError({ code: 'api/numbers/', message: `Hubo un problema al intentar editar los numeros. ${message}` });
  }
}
